import useApiService from "../../../../hooks/useApiService";
import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formDataType } from "../AddSite";
import { SubContractorDetail } from "../../../../models/sub_contractor.interface";

interface SubContractorProps {
  handleChange: (name: string, value: number[]) => void;
  formData: formDataType;
}

export function SubContractor({ handleChange, formData }: SubContractorProps) {
  const [subContractors, setSubContractors] = useState<SubContractorDetail[]>([]);
  const [selectedSubContractors, setSelectedSubContractors] = useState<SubContractorDetail[]>([]);
  const [rowClick, __] = useState(true);

  const { loading: loadingEmployees } = useApiService<SubContractorDetail[]>({
    url: "sub_contractor",
    method: "GET",
    apiName: "core",
    params:{
      bypassSite: true
    },
    onSuccess: res => {
      const selected = res.filter(subContractor => formData?.subContractors?.includes(subContractor.id));
      setSelectedSubContractors(selected);
      setSubContractors(res);
    },
  });

  function handleSelectionChange(e: any) {
    setSelectedSubContractors(e.value as SubContractorDetail[]);
    handleChange(
      "subContractors",
      e.value.map((item: SubContractorDetail) => item.id)
    );
  }
  return (
    <div style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column" }}>
      <p className={"mt-4"}>
        Which subcontractors will be working on site? This can be updated and expanded once the site is
        created as well.
      </p>
      <div style={{ flex: 1, overflowY: "auto", padding: "0 1rem 1rem" }}>
        {/*@ts-ignore*/}
        <DataTable
          value={subContractors ?? []}
          selectionMode={rowClick ? "multiple" : null}
          selection={selectedSubContractors}
          onSelectionChange={(e: any) => {
            handleSelectionChange(e);
          }}
          dataKey={"id"}
          tableStyle={{ minWidth: "50rem" }}
          loading={loadingEmployees}
        >
          <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
          <Column header={"Contractor Name"} field={"name"} style={{ minWidth: "12rem" }} />
          <Column header={"Manager Full Name"} field={"manager_full_name"} />
          <Column header={"Company Registration Number"} field={"company_registration_number"} />
        </DataTable>
      </div>
    </div>
  );
}
